<template>
    <div v-if="!this.inline && this.unstable" class="lspinner-unstable" :class="classNames"></div>
    <div v-else-if="this.inline && !this.unstable" class="lspinner-inline" :class="classNamesInline"></div>
    <div v-else>Conflict spinner</div>
</template>

<script>
export default {
    name: "spinner",

    props: {
        unstable: {
            type: Boolean,
            default: false,
        },
        inline: {
            type: Boolean,
            default: true
        },

        relative: {
            type: Boolean,
            default: false,
        },
        absolute: {
            type: Boolean,
            default: false
        },

        // Size: "xs" | "sm" | "md" | "lg"
        size: {
            type: String,
            default: "md"
        },

        // To read more at "vuexy/_variable.scss"
        color: {
            type: String,
            default: "primary"
        }
    },

    computed: {
        classNames() {
            return {
                [`lspinner-unstable--${this.size}`]: true,
                [`lspinner-unstable--${this.color}`]: true,
                "lspinner-unstable--active": this.loading,
                "lspinner-unstable--relative": this.relative,
                "lspinner-unstable--absolute": this.absolute,
            }
        },
        classNamesInline() {
            return {
                [`lspinner-inline--${this.size}`]: true,
                [`lspinner-inline--${this.color}`]: true,
            }
        }
    }
}
</script>

<style lang="scss">

@import "@sass/vuexy/_variables.scss";

$sizes: (
    "xs": (
        "w": 14px,  
    ),
    "sm": (
        "w": 20px,  
    ),
    "md": (
        "w": 25px,  
    ),
    "lg": (
        "w": 38px,  
    ),
);

.lspinner-unstable {
    &::before {
        content: "";
        width: 30px;
        height: 30px;

        top: 0;
        right: 0;

        position: absolute;

        border-radius: 50%;
        border: 2px solid var(--vs-hex-primary);

        border-left: 2px solid transparent;
        border-bottom: 2px solid transparent;

        animation: lspinner 550ms linear infinite;
    }

    // size
    @each $size, $frame in $sizes {
        &.lspinner-unstable--#{$size} {
            &::before {
                width: map-get($map: $frame, $key: "w");
                height: map-get($map: $frame, $key: "w");
            }
        }
    }

    // color
    @each $type, $color in $colors {
        &.lspinner-unstable--#{$type} {
            &::before {
                border-top-color: $color;
                border-right-color: $color;
            }
        }
    }
   
    // Position
    &.lspinner-unstable--relative {
        position: relative;
    }
    &.lspinner-unstable--absolute {
        position: absolute;
    }
}

// Inline
.lspinner-inline {
    display: inline-block;
    border-radius: 50%;
    border: 2px solid var(--vs-hex-primary);

    border-left: 2px solid transparent;
    border-bottom: 2px solid transparent;

    animation: lspinner 550ms linear infinite;

    // size
    @each $size, $frame in $sizes {
        &.lspinner-inline--#{$size} {
            width: map-get($map: $frame, $key: "w");
            height: map-get($map: $frame, $key: "w");
        }
    }

        // color
    @each $type, $color in $colors {
        &.lspinner-inline--#{$type} {
            border-top-color: $color;
            border-right-color: $color;
        }
    }
}

@keyframes lspinner {
    to {
        transform: rotate(360deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Loading/Spinner.vue